import { reactive } from "vue";
import { ElMessage, ElLoading } from "element-plus";
import { saveFeedbackApi } from "@/api/feedbackApi.js";
export default {
  name: "FeedbackInput",
  setup() {
    let feedback = reactive({
      module: "",
      title: "",
      suggestion: ""
    });
    //更新列表
    function saveFeedback() {
      if (!feedback.module || !feedback.title) {
        ElMessage({
          type: "wring",
          showClose: true,
          message: "请填写信息"
        });
        return 0;
      }
      const loading = ElLoading.service({
        lock: true,
        text: "加载中..",
        background: "rgba(0, 0, 0, 0.7)"
      });
      saveFeedbackApi({
        ...feedback
      }).then(r => {
        loading.close();
        if (r.status < 400) {
          feedback.module = "";
          feedback.title = "";
          feedback.suggestion = "";
          ElMessage({
            showClose: true,
            message: "意见反馈成功！",
            type: "success"
          });
        } else {
          ElMessage({
            type: "error",
            showClose: true,
            message: "意见反馈失败！"
          });
        }
      });
    }
    return {
      feedback,
      saveFeedback
    };
  }
};